import type { QueryClient } from '@tanstack/react-query';

/**
 * Después de una acción sobre un legajo hay que refrescar la ficha Y la tabla
 * de resultados de Búsqueda: la fila muestra estado de persona y de legajo,
 * MS2 y pago, que son justo lo que cambia una sincronización con Binary o una
 * retitularización. Antes se invalidaba solo la ficha y la fila quedaba con
 * los valores viejos hasta un F5 (con `staleTime` de 30 s, ni cerrar y
 * reabrir el drawer la refrescaba).
 *
 * `['busqueda']` matchea `['busqueda', submitted]` por prefijo, y NO
 * `['busqueda-detalle', …]`: el match es por elemento, no por string.
 *
 * Vive fuera de la página porque un archivo de página solo puede exportar
 * componentes (react-refresh).
 */
export function refrescarBusqueda(qc: QueryClient, legajoId: string | null): void {
  qc.invalidateQueries({ queryKey: ['busqueda-detalle', legajoId] });
  qc.invalidateQueries({ queryKey: ['busqueda'] });
}
